import React from 'react';
import './Total.css';

const Total = ({ amount }) => {
    return (
        <div className="fixfee-total-container">
            <span className="fixfee-total-count">${amount.toFixed(2)}</span>
            <span className="fixfee-total-label">Total</span>
        </div>
    );
};

export default Total;
